export const CDN_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const RES_API = "/api/restaurants";

export const MENU_API = "/api/menu?restaurantId=";
